import React from 'react';

import TrustpilotContainer from './TrustpilotContainer';

const MicroTrustScoreComponent = ({ trustBoxRef }) => (
  <span
    ref={trustBoxRef}
    className="trustpilot-widget"
    data-locale="en-GB"
    data-template-id="5419b6a8b0d04a076446a9ad"
    data-businessunit-id="5ce276436ec6da0001bece3d"
    data-style-height="20px"
    data-style-width="100%"
    data-theme="light"
  >
    {' '}
    <a
      href="https://uk.trustpilot.com/review/www.letsdothis.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      Trustpilot
    </a>{' '}
  </span>
);

const MicroTrustScoreContainer = () => (
  <>
    <script
      async
      type="text/javascript"
      src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
    />
    <TrustpilotContainer
      render={({ trustBoxRef }) => (
        <MicroTrustScoreComponent trustBoxRef={trustBoxRef} />
      )}
    />
  </>
);

export default MicroTrustScoreContainer;
